/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
// import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import ButtonBase from '@material-ui/core/ButtonBase';
import Button from '@material-ui/core/Button';
// import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import updateState from '../../actions/updateState';
import translate from '../../actions/translate';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  cardAction: {
    display: 'block',
    textAlign: 'initial',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  button: {
    margin: 0,
  },
});

// eslint-disable-next-line react/prop-types
export default function RestaurantCard({ times }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const restaurant = useSelector((state) => state.formState.Restaurant_found);
  const workWithUs = useSelector((state) => state.formState.alreadyWorkWithUs);
  const restaurantAddress = useSelector(
    (state) => state.formState.Restaurant_address
  );
  return (
    <>
      <Box mt={1} mb={2}>
        {' '}
        <Typography variant="h6">
          {translate('Looks like we found it!')}
        </Typography>
      </Box>

      <Card className={classes.root}>
        <ButtonBase
          focusRipple
          className={classes.cardAction}
          onClick={(e) => e}
        >
          <CardContent>
            <Typography variant="h5" component="h2">
              {restaurant}
            </Typography>

            <Typography variant="body2" component="p">
              {restaurantAddress}
            </Typography>
          </CardContent>

          {/* <CardActions>
        <Button variant="outlined" size="small">
          Not Your Restaurant?
        </Button>
      </CardActions> */}
        </ButtonBase>
      </Card>
      <Typography variant="body2">
        {workWithUs
          ? translate(
              'Looks like you already signed up with us! Please call customer support (404-382-9768) to finish account setup'
            )
          : null}

        {!workWithUs && times <= 2 && restaurant
          ? translate(
              'Not the right one? Enter your restaurant name and address.'
            )
          : null}

        {!workWithUs && times > 2 && restaurant
          ? translate(
              "Still not the right one? Call our customer support line at 404-283-9768 and they'll help you get set up!"
            )
          : null}

        <Box ml={-1}>
          <Button
            className={classes.button}
            onClick={() => {
              dispatch(updateState({ Restaurant_found: null }));
              dispatch(updateState({ showRestaurantSearch: true }));
            }}
          >
            {' '}
            <u>{translate('Search Again')}</u>
          </Button>
        </Box>
      </Typography>
    </>
  );
}
